import Meetings from './meetings.vue'
import PlanningRecords from './planning_records.vue'

export default { Meetings, PlanningRecords }
